import { title as titleCase } from 'case';
import React from 'react';

import { Chip, useTheme } from '@/components/ui';
import { badgeStyles, getStatusStyle } from '@/styles';

// Status badge component
export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
	const theme = useTheme();
	const statusStyle = getStatusStyle(status);
	console.log('statusStyle', status, statusStyle);
	return (
		<Chip
			mode="flat"
			style={{
				...badgeStyles.badge,
				backgroundColor: statusStyle.backgroundColor,
			}}
			textStyle={{ color: statusStyle.color || theme.colors.surface }}
		>
			{titleCase(status)}
		</Chip>
	);
};
